export default {
  Business: 'Business',
  Individual: 'Individual'
}
